import { useValuationTranslation } from '@/pages/CompanyReport/components/Valuation/hooks/useValuationTranslation';

type BaseMetricLabel =
  | 'Sales'
  | 'Book'
  | 'Earnings'
  | 'Forecasted Earnings in 12m'
  | 'Forecasted Sales in 12m';

type Metric = 'PB' | 'PS' | 'Forward PS' | 'PE' | 'Forward PE' | 'n/a';

export const useBaseMetricLabel = () => {
  const t = useValuationTranslation();
  return (metricLabel: BaseMetricLabel) => {
    switch (metricLabel) {
      case 'Sales':
        return t('keyMetric.psBaseMetric');
      case 'Book':
        return t('keyMetric.pbBaseMetric');
      case 'Forecasted Earnings in 12m':
        return t('keyMetric.forwardPEBaseMetric');
      case 'Forecasted Sales in 12m':
        return t('keyMetric.forwardPSBaseMetric');
      case 'Earnings':
        return t('keyMetric.peBaseMetric');
    }
  };
};

export const useSecondMetricLabel = () => {
  const t = useValuationTranslation();
  return (metric: Metric) => {
    switch (metric) {
      case 'Forward PE':
        return t('keyMetric.eps');
      default:
        return t('keyMetric.marketCap');
    }
  };
};

export const useCalculatedBaseMetricLabel = () => {
  const t = useValuationTranslation();
  return (metricLabel: BaseMetricLabel) => {
    switch (metricLabel) {
      case 'Sales':
        return t('keyMetric.psBaseCalculatedMetric');
      case 'Book':
        return t('keyMetric.pbBaseCalculatedMetric');
      case 'Forecasted Earnings in 12m':
        return t('keyMetric.forwardPEBaseCalculatedMetric');
      case 'Forecasted Sales in 12m':
        return t('keyMetric.forwardPSBaseCalculatedMetric');
      case 'Earnings':
        return t('keyMetric.peBaseCalculatedMetric');
      default:
        return t('keyMetric.defaultBaseCalculatedMetric');
    }
  };
};

export const useMetricRatioLabel = () => {
  const t = useValuationTranslation();
  return (metric: Metric) => {
    switch (metric) {
      case 'PB':
        return t('keyMetric.pbRatio');
      case 'PS':
        return t('keyMetric.psRatio');
      case 'Forward PS':
        return t('keyMetric.forwardPSRatio');
      case 'PE':
        return t('keyMetric.peRatio');
      case 'Forward PE':
        return t('keyMetric.forwardPERatio');
      case 'n/a':
        return t('keyMetric.notAvailable');
    }
  };
};
